import Link from 'next/link';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  paddingTop?: string;
  paddingBottom?: string;
}

export default function Breadcrumbs({ items, paddingTop = '16px', paddingBottom = '20px' }: BreadcrumbsProps) {
  return (
    <div>
      <nav className="container" style={{ paddingTop, paddingBottom }} aria-label="Breadcrumb">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          <li>
            <Link
              href="/"
              className="text-[var(--color-text-secondary)] hover:text-black transition-colors"
            >
              Home
            </Link>
          </li>
          {items.map((item, i) => (
            <li key={i} className="flex items-center gap-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-3 h-3 text-[var(--color-text-muted)]"
                aria-hidden="true"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
              </svg>
              {item.href ? (
                <Link
                  href={item.href}
                  className="text-[var(--color-text-secondary)] hover:text-black transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-[var(--color-text-primary)] font-medium">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  );
}
